import { Component, Injectable, Input, OnInit, Output, EventEmitter, ElementRef } from '@angular/core';


// Data model
import {CouponModel, ShopCouponRefresh} from 'abs-ngx-library/src/lib/core';
import { CommonService , UserInfoService , CartService , UtilService , ProductCouponService, CartV2Service } from 'abs-ngx-library/src/lib/core';

import { IConfigObj } from 'abs-ngx-library/src/lib/core';
import { isShellDrawerApp } from '../product-coupon.constants';


// jQuery
declare let $: any;


@Component({
    selector: 'product-coupon-al-v1',
    templateUrl: './product-coupon-al-v1.component.html',
    providers: [ProductCouponService]
})

@Injectable()
export class ProductCouponALV1Component implements OnInit {

    @Input() product: any;
    @Input() parentComponent: string;
    @Input() productOffers: any;
    @Input() couponCalledBy: string;
    // Decision inputs
    @Input() showDetailsLink = true;
    @Input() showOfferComplete = true;
    @Input() isClickableMultipleCoupons = true;
    @Input() configObj?: IConfigObj;
    @Input() includeOffer = false;

    @Output() productCouponDetails: EventEmitter<any> = new EventEmitter<any>();
    @Output() singleCouponClip: EventEmitter<any> = new EventEmitter<any>();

    public coupons: any[] = [];
    public availableOffersCounter = 0;
    public offersClippedCounter = 0;
    public singleCouponText: string;
    public productDetails: any;
    private _carouselTitle: any;
    private cartDetails: any;

    private isWYSIWYGEnabled = false;
    public isValidCouponBOGO = false;

    public clippedText = 'Clipped';
    public offerCompletedText = 'Offer Complete!';
    public personalizedPriceLabel = 'Personalized Price: ';

    // Boxtop modal variables
    public showBoxtop = false;
    public modalAttrName = 'modal';
    public modalIdName = '#boxtop-modal';
    public adaText = '';
    public isProductCardV2 = false;

    // CMS BOGO texts
    public bogoText = 'Buy 1 Get 1 Free - ';
    public bogoTextDetail = 'Add 2 Total for Offer';

    // Multiple coupons texts
    public someCompletedCouponsText = '<completed> of <counter> Offers Complete';
    public allCompletedCouponsText = '<completed> Offers Complete';
    public someClippedCouponsText = '<clipped> of <counter> Offers Clipped';
    public someCouponsText = '<counter> Offers Available';
    public clippedCompletedCoupons: string;
    public availableCoupons = '';
    public NDCCoupons;

    @Input()
    set carouselTitle(carouselTitle: any) {
        this._carouselTitle = carouselTitle;
    }

    get carouselTitle(): any {
        return this._carouselTitle;
    }

    public constructor(
        private _commonService: CommonService,
        private _userInfoService: UserInfoService,
        private _elementRef: ElementRef,
        private cartService: CartService,
        private _utilService : UtilService,
        private _productCouponService : ProductCouponService,
        private cartV2Service: CartV2Service
    ) {

    }

    public ngOnInit() {
      this.isProductCardV2 = true;

      this.product.isBOGO = this.isBogoOffer();

      // get coupons from offers if is product carousel item
      if (this.productOffers && typeof this.productOffers['offers'] !== 'undefined' && this.productOffers['offers'] != null) {

          if (!this._commonService.objPageCoupons['offersByUpc'].hasOwnProperty(this.product.upc)) {
              this._commonService.objPageCoupons['offersByUpc'][this.product.upc] = [];
          }

        for (const offer in this.productOffers.offers) {
            if (this.productOffers.offers.hasOwnProperty(offer) && !this.couponIsExpired(this.productOffers.offers[offer])) {
                const offerObj = this.productOffers.offers[offer];
                if (!(offerObj.hasOwnProperty('deliveryChannel') && offerObj.deliveryChannel === 'EC')) {
                    this.coupons.push(offerObj);
            
                    this._commonService.objPageCoupons['offers'][offer] = offerObj;
            
                  if (!this._commonService.objPageCoupons['offersByUpc'][this.product.upc].includes(offer)) {
                    this._commonService.objPageCoupons['offersByUpc'][this.product.upc].push(offer);
                  }
                }
            }
        }
      }

      // get coupons from localStorage if empty
      if (this.coupons.length === 0 && !this.includeOffer) {
          this._processFromLocalStorage();
      }

      this._init();

      this._commonService.shopCouponRefreshSource.subscribe((couponRefresh: ShopCouponRefresh) => {
        if (couponRefresh && typeof couponRefresh === 'object' && 'id' in couponRefresh && 'deleted' in couponRefresh && 'status' in couponRefresh) {
            this._processFromLocalStorage();
            if(typeof couponRefresh === 'object') {
                const coupon = this.coupons.find(coupon => coupon.offerId === couponRefresh.id);
                if (coupon) {
                    coupon.deleted = couponRefresh.deleted;
                    coupon.status = couponRefresh.status;
                    this.coupons = [...this.coupons];
                }
            }
            const tempCoupons = JSON.parse(JSON.stringify(this.coupons));
            const tempNDCCoupons = JSON.parse(JSON.stringify(this.NDCCoupons));
            if (tempCoupons.length > 0) {
                this.coupons = this.cartService.processOfferComplete(this.cartDetails, tempCoupons, this.product);
            }
            if (tempNDCCoupons.length > 0) {
                this.NDCCoupons = this.cartService.processOfferComplete(this.cartDetails, tempNDCCoupons, this.product);
            }
            this.cartService.processBOGOComplete(this.cartDetails, this.product);
            this._init();
        }
      });

      // check and update statuses when cart is updated
      this._commonService.currentCartObj.subscribe(objCart => {
          const singleCart =
              this.cartV2Service.fetchCartDetailsFromResponse(objCart, this.cartV2Service.getCartName(this.configObj.programType));
          this.cartDetails = singleCart;
          this.isWYSIWYGEnabled = this.cartDetails['isWYSIWYGEnabled'];
          const tempCoupons = JSON.parse(JSON.stringify(this.coupons));
          const tempNDCCoupons = JSON.parse(JSON.stringify(this.NDCCoupons));
          if (tempCoupons.length > 0) {
              this.coupons = this.cartService.processOfferComplete(this.cartDetails, tempCoupons, this.product);
          }
          if (tempNDCCoupons.length > 0) {
              this.NDCCoupons = this.cartService.processOfferComplete(this.cartDetails, tempNDCCoupons, this.product);
          }
          this.cartService.processBOGOComplete(this.cartDetails, this.product);

          if (this.availableOffersCounter > 1) {
              this.setOfferCompleteText();
          }
      });
  }

  private _init() {

      // check number of offers available
      this.coupons = this.coupons.filter(coupon => coupon.isClippable || (!coupon.isClippable && coupon.ecomDescription));
      this.availableOffersCounter = (this.coupons) ? this.coupons.length : 0;
      this.NDCCoupons = this.coupons.filter(coupon => coupon.isClippable === false);
      this.NDCCoupons = this.coupons.filter(coupon => coupon.isClippable === false && coupon.ecomDescription);
      if (this.isBogoOffer()) {
          this.availableOffersCounter = this.availableOffersCounter + 1;
      }

      // check number of offers clipped
      this.offersClippedCounter = (this.availableOffersCounter > 0) ? this._productCouponService.getOffersClipped(this.coupons) : 0;
      if (this.isBogoOffer()) {
          this.offersClippedCounter = this.offersClippedCounter + 1;
      }

      // set text for multiple coupons
      this.setOfferCompleteText();

      // set text for bogo cms
      this.setBogoText();

      // set text for single coupon
      if (this.availableOffersCounter === 1 && this.coupons.length === 1) {
          this.singleCouponText =
            this.coupons[0].offerPgm && this.coupons[0].offerPgm === 'PD'
            ? 'Personalized Price: ' + this.coupons[0].ecomDescription
            : this.coupons[0].ecomDescription;
          this.coupons[0].offerComplete = this.coupons[0].offerComplete ? this.coupons[0].offerComplete : false;
      }

      this.productDetails = {
          'product': this.product,
          'offerCounter': this.availableOffersCounter,
          'offerClipped': this.offersClippedCounter,
          'coupons': this.coupons
      };
      this.productCouponDetails.emit(this.productDetails);

      // check if the coupons are available
      this.isValidCouponBOGO = this.availableOffersCounter > 0
          || (this.isBogoOffer() && this._commonService.isProductPromoActive(this.product));

      // set text when all coupons are unclipped
      if (this.availableOffersCounter > 1) {
          this.availableCoupons = this.someCouponsText.replace('<counter>', this.availableOffersCounter.toString());
      }
  }

    /**
     * Helper function which sets BOGO CMS promo attributes.
     */

    private setBogoText() {
        this.bogoText = this.product.promoDescription ? `${this.product.promoDescription}${this.configObj.programType !== '1P_SNS' ? '-' : ''}` : '';
        this.bogoTextDetail = this.product.promoText ? this.product.promoText : '';
    }

    /**
     * Helper function that validates bogoText and bogoTextDetail promo attributes string length and returns boolean.
     */

    public validateBogoTexts() {
        if (this.bogoText.length > 0 && this.bogoTextDetail.length > 0) {
            return true;
        }
        return false;
    }

    private setOfferCompleteText() {

      let completedCouponsLength =
          this.isWYSIWYGEnabled === true && this.coupons && this.coupons.length > 0
              ? this._productCouponService.getCouponsCompletedCounter(this.coupons)
              : 0;

      if (this.isBogoOffer() && this.product.offerComplete && this.product.offerComplete === true) {
          completedCouponsLength = completedCouponsLength + 1;
      }

      if (completedCouponsLength > 0) {
          if (completedCouponsLength === this.availableOffersCounter) {
              // all the offers are complete
              this.clippedCompletedCoupons = this.allCompletedCouponsText
                  .replace('<completed>', completedCouponsLength.toString());
          } else {
              // some offers are complete
              this.clippedCompletedCoupons = this.someCompletedCouponsText
                  .replace('<completed>', completedCouponsLength.toString())
                  .replace('<counter>', this.availableOffersCounter.toString());
          }
      } else {
          // show clipped coupons
          this.setSomeClippedCouponsText(this.offersClippedCounter, this.availableOffersCounter);
      }
  }

  /**
   * Set the text for multiple coupons
   *
   * @param clipped - number of clipped coupons/offers
   * @param counter - number of total coupons/offers
   */
  private setSomeClippedCouponsText(clipped: any, counter: any): void {
      this.clippedCompletedCoupons = this.someClippedCouponsText
          .replace('<clipped>', clipped.toString())
          .replace('<counter>', counter.toString());
  }

  /**
   * @return true or false if the product is a BOGO offer
   */
  public isBogoOffer(): boolean {
      return (this.product.promoType === 'M' || this.product.promoType === 'B') && this._commonService.isProductPromoActive(this.product);
  }

  /**
   * Get the coupons based on parent component
   */
  private _processFromLocalStorage() {
      let couponsResult = [];

      if (localStorage.getItem('abCoupons')) {
        //   couponsResult = this.parentComponent === 'minicart'
        //       ? this._commonService.getClippedCouponByUpc(this.product.upc).clippedCoupons
        //       : this._commonService.getCouponByUpc(this.product.upc);
      } else {
          const offers = [];
          if (this._commonService.objPageCoupons
              && this._commonService.objPageCoupons['offersByUpc']
              && this._commonService.objPageCoupons['offersByUpc'][this.product.upc]
              && this._commonService.objPageCoupons['offers']) {
              this._commonService.objPageCoupons['offersByUpc'][this.product.upc].forEach(offer => {
                  offers.push(this._commonService.objPageCoupons['offers'][offer]);
              });
          }
          couponsResult = this.parentComponent === 'minicart'
              ? offers.filter(offer => offer.status === 'C')
              : offers;
      }

      if (this.parentComponent === 'minicart') {
          this.coupons = this.getCouponsFromProduct(couponsResult);
      } else {
          this.coupons = couponsResult;
      }
  }

  public getCouponsFromProduct(coupons) {

      let savingsAndClippedUnion = [];
      const clipped = this.product.clipped || [];
      let savings = this.product.savings || [];

      if (savings) {
          savings = savings.filter(coupon => coupon.display == true && coupon.source !== 'CMS');
      }

      // Unite coupons from savings and clipped
      savingsAndClippedUnion = [...clipped, ...savings].filter((set =>
              (coupon: any) => set.has(coupon.offerId) ? false : set.add(coupon.offerId)
          )(new Set())).map(obj => ({
              ...obj,
              status: 'C',
              offerId: obj.omsOfferId,
              ecomDescription: obj.displayOfferTxt,
              deleted: false
          }));

      // Unite coupons from savings+clipped and from localeStorage abCoupons, filter them to re
      const allCoupons = [...savingsAndClippedUnion, ...coupons].filter((set =>
          (coupon: any) => set.has(coupon.offerId) ? false : set.add(coupon.offerId)
      )(new Set()));

      return allCoupons;
  }

  public couponIsExpired(coupon) {
      return this._productCouponService.isCouponExpired(coupon);
  }

  public productPromoIsActive(product) {
      return this._commonService.isProductPromoActive(product);
  }

  /**
   * Clip coupon when only one is available
   */
  public clipCoupon() {

      if (this.coupons[0]['offerSubPgm'] === '07' && (window['AB'].userInfo.boxTopAuth || !this._isRegistered())) {
          this.modalAttrName = '';
          this.modalIdName = '';
      }

      if (this._isRegistered()) {

          const storeId = window['AB']['userInfo']['branchId'];
          this._updateAnalyticsDataLayer();
          this._updateAnalyticsCarouselName();
          const analyticsData = {
            nativeElement: this._elementRef.nativeElement
          };
          this._productCouponService.clipCoupon(this.coupons[0], storeId, null, analyticsData).subscribe(response => {

              if (response && response['items'] && response['items'][0] && response['items'][0]['status'] === 1) {

                  this.offersClippedCounter = 1;
                  this.coupons[0].status = 'C';
                  this.coupons[0].deleted = false;

                  this._commonService.sendSponsoredProductClickEventForAllowedRoutes(this.product, 'productCoupon', 'clipCoupon');

                  // Broadcast to other components
                  this._commonService.shopCouponRefreshSource.next({
                  id: this.coupons[0]?.offerId,
                  status: 'C',
                  deleted: false
                 });
                  this.trackCRSClick('coupon-clip-click', response);
                  setTimeout(() => {
                      $('#clippedCoupon' + this.coupons[0].offerId).focus();
                      this.adaText = 'This coupon has been clipped.';
                  }, 100);

                  setTimeout(() => {
                      this.adaText = '';
                  }, 500);

                  this.singleCouponClip.emit(this.productDetails);
                  
                  const pageType = $('.product-info').attr('data-pagetype');
                  if (pageType === 'pdp') {
                    window.dispatchEvent(new CustomEvent('DigitalCouponClipped', { detail: { offerId: response["items"][0].itemId } }));
                  }
              }

          });
      } else {
            window['AB']['COMMON'].showSignInModal_OTP(window.location.href);
      }
  }

  /**
   * Analytics method for updating productInfo
   */
  private _updateAnalyticsDataLayer(): void {
      if (window['AB'] && window['AB']['DATALAYER']) {
          const analyticsCarouselTitle = this._carouselTitle ||
              window['AB']['DATALAYER'].getAnalyticsCarouselTitle(this._elementRef.nativeElement);
          window['AB']['DATALAYER'].productInfo({
              id: this.productDetails.product.id,
              name: this.productDetails.product.name,
              units: this.productDetails.product.units,
              listPrice: this.productDetails.product.price,
              basePrice: this.productDetails.product.basePrice,
              carouselSection: analyticsCarouselTitle || '',
              pricingType: this.productDetails.product.promoDescriptionVal || '',
              couponID: this.productDetails.coupons.filter(offer => offer.status === 'C').map(offer => offer.offerId).toString(),
              couponFlag: this.productDetails.offerCounter,
              couponClipped: this.offersClippedCounter,
              aisleId: this.productDetails.product.aisleId,
              upc: this.productDetails.product.upc
          });
      }
  }

  /**
   * Analytics method for sending the offer info with the linkClick event
   * param offerType
   * param offerName
   */
  private _updateAnalyticsLinkClick(offerType, offerName): void {
      if (window['AB'] && window['AB']['DATALAYER']) {
          if (offerName) {
              window['AB']['DATALAYER'].setLinkClickOfferDrawer(offerType, offerName, this._elementRef.nativeElement);
          } else {
              let multipleText = '';
              if (this.offersClippedCounter === 0) {
                  multipleText = `${this.availableOffersCounter} Coupons Available`;
                  window['AB']['DATALAYER'].setLinkClickOfferDrawer(offerType, multipleText, this._elementRef.nativeElement);
              } else if (this.offersClippedCounter > 0) {
                  multipleText = `${this.offersClippedCounter} of ${this.availableOffersCounter} Coupons Clipped`;
                  window['AB']['DATALAYER'].setLinkClickOfferDrawer(offerType, multipleText, this._elementRef.nativeElement);
              }
          }
      }
  }

  private trackCRSClick(linkName: string, response?: any): void {
      const dataLayer = window['AB'] && window['AB']['DATALAYER'];
      if (!dataLayer || dataLayer.setCRSClickEvent === undefined || !dataLayer.isHomePage || !dataLayer.isHomePage()) {
          return;
      }

      const placement = localStorage.getItem('analyticsProductPlacement') || window['digitalData']?.pageFilter?.placement;
      const section = this._carouselTitle || dataLayer.getAnalyticsCarouselTitle?.(this._elementRef.nativeElement) || this.product?.carouselSection || 'no-val';
      const coupon = this.coupons?.[0] || {};
      const payload: any = {
          linkName,
          mTyp: 'product-carousel',
          element: this._elementRef.nativeElement,
          placement,
          component: dataLayer.getCRSComponent({
              element: this._elementRef.nativeElement,
              section,
              detail: this.product?.adobeMetrics?.metricA || this.product?.impressionAdditionalDetail || 'no-val',
              placement
          })
      };

      if (linkName === 'coupon-clip-click') {
          const clippedItem = response?.items?.[0] || {};
          payload.batchCouponsClipped = [{
              type: coupon?.offerPgm || coupon?.offerType || coupon?.offerProgramType || 'no-val',
              name: coupon?.brand || coupon?.name || coupon?.description || this.product?.name || 'no-val',
              id: String(coupon?.offerId || coupon?.couponID || clippedItem?.itemId || 'no-val'),
              clipMthd: 'singleclip',
              carouselSec: section,
              clipCnt: '1',
              clipID: clippedItem?.clipId || clippedItem?.clipID || response?.clipID || 'no-val',
              clipTime: new Date().toISOString(),
              divisionName: window['AB']?.userInfo?.divisionName || window['AB']?.userInfo?.division || 'no-val',
              msgData: coupon?.msgData || coupon?.messageData || coupon?.analyticsTag || 'no-val',
              savings: String(coupon?.savings || coupon?.savingsValue || '0')
          }];
      }

      dataLayer.setCRSClickEvent(payload);
  }

  private _updateAnalyticsModalViewSNS(name: string): void {
    if (window['AB'] && window['AB']['DATALAYER']) {
      window['AB']['DATALAYER'].setModalViewEvents(name);
    }
  }
  
  /**
   * Analytics method for updating the carousel name
   */
  private _updateAnalyticsCarouselName(): void {
      if (window['AB']['DATALAYER'] && this._carouselTitle) {
          window['AB']['DATALAYER'].setCarouselName('shop|' + this._carouselTitle);
      }
  }

    public setProductDetails(drawerType: string, coupon?: CouponModel): void {
        this._commonService.sendSponsoredProductClickEventForAllowedRoutes(this.product, 'productCoupon', 'couponClick');
        if (drawerType === 'offer-detail' || drawerType === 'coupon-list') {
            this.trackCRSClick('offer-details-click');
        }
        //Check if 1P_SNS programType is set and emit event else do default behavior
        if (this.configObj.programType === '1P_SNS') {
            switch (drawerType) {
                case 'offer-detail':
                    this._commonService.dispatchCustomOneTimeEvent('snsOneTime', 'singleCoupon',{ coupons:this.coupons[0] });
                    this._updateAnalyticsModalViewSNS('offer-details-j4u-productcards|view');
                    break;
                case 'coupon-list':
                    this._commonService.dispatchCustomOneTimeEvent('snsOneTime', 'multipleCoupons',{ product: this.product });
                    this._updateAnalyticsModalViewSNS('offer-details-multiple-productcards|view');
                    break;
            }
        } else {
            let objDrawerData = {};
            // reset name property to default value to properly display the tooltip.
            if (drawerType === 'coupon-list') {
                objDrawerData = {
                    type: drawerType,
                    couponList: this.coupons,
                    product: this.product
                };
                this._updateAnalyticsLinkClick('offer-drawer-multiple-productcards', null);
            } else if (drawerType === 'offer-detail') {
                if (this.parentComponent && this.parentComponent === 'minicart') {
                    objDrawerData = {
                        type: drawerType,
                        coupon: coupon ? coupon : this.coupons[0],
                        product: this.product,
                        triggeredElement: 'mini-cart'
                    };
                    this._updateAnalyticsLinkClick('offer-drawer-j4u-minicart', this.singleCouponText);
                } else {
                    if (this.parentComponent && this.parentComponent === 'product-detail') {
                        objDrawerData = {
                            type: drawerType,
                            coupon,
                            product: this.product,
                            triggeredElement: 'single-coupon-product-card'
                        };
                    } else {
                        objDrawerData = {
                            type: drawerType,
                            coupon: this.coupons[0],
                            product: this.product,
                            triggeredElement: 'single-coupon-product-card'
                        };
                    }
                    this._updateAnalyticsLinkClick('offer-drawer-j4u-productcards', this.singleCouponText);
                }
            } else if (drawerType === 'bogo-detail') {
                if (this.parentComponent && this.parentComponent === 'minicart') {
                    objDrawerData = {
                        type: drawerType,
                        product: this.product,
                        triggeredElement: 'mini-cart'
                    };
                    this._updateAnalyticsLinkClick('offer-drawer-bogo-minicart', this.bogoText);
                } else {
                    objDrawerData = {
                        type: drawerType,
                        product: this.product,
                        triggeredElement: 'single-coupon-product-card'
                    };
                    this._updateAnalyticsLinkClick('offer-drawer-bogo-productcards', this.bogoText);
                }
            }
            objDrawerData = { ...objDrawerData, configObj: this.configObj };
            if (isShellDrawerApp(this.configObj?.appName) && window['rightdrawerCompAlRef']) {
                window['rightdrawerCompAlRef'].zone.run(() => {
                    window['rightdrawerCompAlRef'].component.openRightDrawer(objDrawerData);
                });
            } else {
                this._commonService.rightDrawerSource.next(objDrawerData);
            }
        }
    }

  public openJ4UModal(event): void {
      if (this.couponCalledBy !== 'c-products-by-upc' && this.couponCalledBy !== 'offer') {
          const clickedCouponId = event.target.id;
          $('#offerDetailModal').find('.modal-body').load(event.target.pathname, () => {
              this._commonService.initJ4UModal();
              $('#offerDetailModal #loadingConMedium').hide();
              $('#offerDetailModal').modal({ show: true, backdrop: 'static' }, $(`#${clickedCouponId}`));
          });
      } else {
          $('html, body').animate({ scrollTop: 0 }, 'slow');
      }
  }

  public getProductFullName() {
      let fullName = '';

      if (this.productDetails && this.productDetails.product) {
          fullName =  this.productDetails.product.fullName && this.productDetails.product.fullName.length ?
              this.productDetails.product.fullName : this.productDetails.product.name;
      }

      return fullName;
  }

    /**
     * Method for checking if there is a single offer and is a BOGO
     * @return true or false if token is active and use is authorized
     */
  private _isRegistered(): boolean {
     return (this._utilService.isTokenActive() && this._userInfoService.isAuthorized());
  }

  /**
   * Method for checking if there is a single offer and is a coupon
   *
   * @return true or false based on the number of available offers
   */
  public isSingleOffer(): boolean {
      return this.parentComponent === 'minicart'
          ? this.availableOffersCounter === 1 && !this.product.isBOGO
          : (this.availableOffersCounter === 1 && this.isProductCardV2 === false)
              || (this.availableOffersCounter === 1 && this.isProductCardV2 === true && !this.product.isBOGO);
  }

  /**
   * Method for checking if there is a single offer and is a BOGO
   *
   * @return true or false if the number of available offers is 1 and is a BOGO
   */
  public isSingleBogoOffer(): boolean {
      return this.parentComponent === 'minicart' || this.parentComponent === 'product-detail'
          ? this.product.isBOGO && this.productPromoIsActive(this.product)
          : this.availableOffersCounter === 1 && this.isProductCardV2 && this.product.isBOGO &&  this.productPromoIsActive(this.product);
  }

  /**
   * Method for cheching if there are multiple offers to show
   *
   * @return true or false based on the number of available offers
   */
  public isMultipleOffer(): boolean {
      return this.availableOffersCounter > 1;
  }

    /**
     * Method for cheching if there are multiple NDC offers to show
     *
     * @return true or false based on the number of available offers
     */
    public isMultipleNDCOffer(): boolean {
        return this.NDCCoupons.length > 0;
    }

  /**
   * Method which is checking if the offer complete has to be shown
   *
   * @param item - this can be product, coupon or any other object with offerComplete
   * @return true or false based on the item and the showOfferComplete input
   */
  public isOfferCompleteVisible(item: any): boolean {
      if (this.isSingleOffer()) {
          return this.isCartProduct() && item.offerComplete && this.showOfferComplete;
      } else {
          return item.offerComplete && this.showOfferComplete;
      }
  }

    public isCartProduct() {
        const cartItemsList = this.cartDetails.cartItems;

        if (cartItemsList) {
            if (this.product.id) {
                return cartItemsList.find((item: any) => item.itemId.toString() === this.product.id.toString());
            } else if (this.product.itemId) {
                return cartItemsList.find((item: any) => item.itemId.toString() === this.product.itemId.toString());
            }
        }

        return false;
    }
}
